import React, { useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
import "../Main.css";
import { partners } from "./pressData";

const PressLogo: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const logo = location.state?.logo;

  const partner = id ? partners[Number(id)] : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

 
  const handleBack = () => {

    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate("/press"); 
    }
  };

  if (!partner) {
    return (
      <>
        <Header />
        <div className="container py-5" style={{ marginTop: "100px" }}>
          <p>No partner data found.</p>
          <button className="back-btn" onClick={handleBack}>
            ← Back
          </button>
        </div>
        <Footer />
      </>
    );
  }

  const renderPartnerCard = (p: any) => (
    <div className="press-card">
      <div className="press-header">
        <div className="press-header-left">
          {logo && <img src={logo} alt={p.name} className="press-logo" loading="lazy" />}
          <h2 className="press-title" style={{ marginTop: "0px" }}>{p.name}</h2>
        </div>
        <div className="press-price">{p.price}</div>
      </div>

      <div className="press-description">{p.description}</div>

      <div className="press-stats">
        <div className="press-stat">
          <p>Words Allowed</p>
          <h4>{p.stats?.wordsAllowed}</h4>
        </div>
        <div className="press-stat">
          <p>Backlinks Allowed</p>
          <h4>{p.stats?.backlinksAllowed}</h4>
        </div>
        <div className="press-stat">
          <p>Sponsored Disclaimer</p>
          <h4>{p.stats?.sponsoredDisclaimer}</h4>
        </div>
      </div>

      <div className="press-footer">
        <div className="press-links">
          <div className="press-link-item">
            <span>Samples</span>
            <a href={p.links?.samples} target="_blank" rel="noopener noreferrer">Link</a>
          </div>
          <div className="press-link-item">
            <span>DA Checker</span>
            <a href={p.links?.daChecker} target="_blank" rel="noopener noreferrer">Link</a>
          </div>
          <div className="press-link-item">
            <span>Traffic Checker</span>
            <a href={p.links?.trafficChecker} target="_blank" rel="noopener noreferrer">Link</a>
          </div>
        </div>

        <button className="press-btn" onClick={() => navigate("/contact-us")}>
          Enquiry Now
        </button>
      </div>
    </div>
  );

  return (
    <>
      <div style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}>
        <Header />
      </div>
      <section className="bg-gray-50 pb-20 pt-10 px-4" style={{ marginTop: "90px" }}>
        <div className="container mb-5">
          <button
            type="button"
            className="back-btn mb-4"
            onClick={handleBack}
          >
            ← Back
          </button>
          
          <div>
            {renderPartnerCard(partner)}
            {partner.brand2 && <div className="mt-5">{renderPartnerCard(partner.brand2)}</div>}
            {partner.brand3 && <div className="mt-5">{renderPartnerCard(partner.brand3)}</div>}
            {partner.brand4 && <div className="mt-5">{renderPartnerCard(partner.brand4)}</div>}
            {partner.brand5 && <div className="mt-5">{renderPartnerCard(partner.brand5)}</div>}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PressLogo;